export const BACKEND_ENDPOINT = '/backend/';